const {Cached, EXPIRATION, INVALID} = require('./cached');

class Cache {
    constructor() {
        this.clear();
    }

    clear() {
        this.data = {};
    }

    delete(url = '') {
        if (this.data[url]) {
            this.data[url] = INVALID;
        }
    }

    getCachedElement(url = '') {
        return this.data[url] || INVALID;
    }

    getCached(url = '') {
        const cached = this.getCachedElement(url);
        this.deleteIfExpired(url);
        return cached;
    }

    deleteIfExpired(url) {
        const {valid = false} = this.getCachedElement(url);

        if (!valid) {
            this.delete(url);
        }
    }

    push({url, promise, expiration = EXPIRATION.ONCE}) {
        this.data[url] = new Cached({url, promise, expiration});
    }

    get(url = '', expiration = EXPIRATION.ONCE) {
        const cached = this.getCached(url);
        return cached.valid && cached.expiration === expiration ? cached : INVALID;
    }
}

module.exports = Cache;
